import React, { useEffect } from 'react';

import { useAuth0 } from '@auth0/auth0-react';
import LoadingIndicator from '@dashboard/components/loading/LoadingIndicator';

export default function Auth0Logout(): JsxNode {
  const { logout } = useAuth0();
  useEffect(() => {
    logout({
      logoutParams: {
        returnTo: `${window.location.origin}/logout/confirmation`,
      },
    });
  });
  return <LoadingIndicator />;
}
